import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([
  'Container',
  'Title',
  'SubTitle',
]);

const HeroSection = helpers.defineMultiStyleConfig({
  baseStyle: {
    Container: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      width: '100%',
      minHeight: '200px',
      padding: '3rem 1rem',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      color: '#ffffff',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 1,
      },
      '> *': {
        position: 'relative',
        zIndex: 2,
      },
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        minHeight: '200px',
        padding: '2rem 1rem',
      },
    },
    Title: {
      fontSize: { base: '2.5rem', md: '3.5rem', lg: '4rem' },
      fontWeight: '700',
      lineHeight: '1.2',
      marginBottom: '1rem',
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
      maxWidth: '800px',
    },
    SubTitle: {
      fontSize: { base: '1.25rem', md: '1.5rem' },
      fontWeight: '400',
      lineHeight: '1.5',
      marginBottom: '2rem',
      textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
      maxWidth: '700px',
      opacity: '0.9',
    },
  },
  sizes: {
    sm: {
      Container: {
        minHeight: '200px',
        padding: '2rem 1rem',
      },
      Title: {
        fontSize: { base: '2rem', md: '2.5rem' },
      },
      SubTitle: {
        fontSize: { base: '1rem', md: '1.25rem' },
      },
    },
    md: {
      Container: {
        minHeight: '200px',
        padding: '3rem 1rem',
      },
      Title: {
        fontSize: { base: '2.5rem', md: '3.5rem' },
      },
      SubTitle: {
        fontSize: { base: '1.25rem', md: '1.5rem' },
      },
    },
    lg: {
      Container: {
        minHeight: '350px',
        padding: '4rem 1rem',
      },
      Title: {
        fontSize: { base: '3rem', md: '4rem', lg: '5rem' },
      },
      SubTitle: {
        fontSize: { base: '1.5rem', md: '1.75rem' },
      },
    },
    xl: {
      Container: {
        minHeight: '400px',
        padding: '5rem 1rem',
      },
      Title: {
        fontSize: { base: '3.5rem', md: '5rem', lg: '6rem' },
      },
      SubTitle: {
        fontSize: { base: '1.75rem', md: '2rem' },
      },
    },
  },
  variants: {
    default: {
      Container: {
        backgroundColor: '#1a202c',
        color: '#ffffff',
      },
    },
    gradient: {
      Container: {
        backgroundImage: 'linear-gradient(to right, #6a11cb, #2575fc)',
        '&::before': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
      },
    },
    dark: {
      Container: {
        backgroundColor: '#1a202c',
        color: '#ffffff',
      },
    },
    light: {
      Container: {
        backgroundColor: '#f7fafc',
        color: '#1a202c',
        '&::before': {
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
    transparent: {
      Container: {
        backgroundColor: 'transparent',
        '&::before': {
          display: 'none',
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'default',
  },
});

export default HeroSection;
